<template>
  
    <el-container>
     
      <el-main>
       <h1>关联思维导图节点和标注</h1>
        <h3>方法 1</h3>

        <p>使用 <i> obsidian://jump-to-pdf</i> 协议 </p>
        <ul>
            <li>在设置页面打开 <i>jump-to-pdf</i>协议支持</li>
            <li>当你点击标注时，将会自动创建链接至粘贴板</li>
            <li>粘贴到md文件中或者节点</li>
            <li>优点是该链接支持从其他应用跳转到 obsidian</li>
        </ul>

        <h3>方法 2</h3>
        <p>首先需要在设置页面选择使用 markdown 文本保存标注数据</p>
        <ul>
            <li>可以使用语法 <i>[[${md name}#${block reference}]]</i> 去关联标注数据.</li>
            <li>点击将会自动跳转到标注</li>
        </ul>

        <div>
            <img src="../assets/markmind/annotate.gif" alt="" width="800">
        </div>
        <div>
            <img src="../assets/markmind/annotate1.gif" alt="" width="800">
        </div>

        <div>
          目前支持创建标注时自动添加到思维导图，如果你不想要该功能，可以在设置页面关闭
        </div>

      </el-main>
    </el-container>
 
</template>

<script>
export default {
  name: 'relatePage',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
